export * as WideCarousel from './index.pc'
export * as MobileCarousel from './index.mobile'
